const formatTime = (date: any) => {
  let hour = new Date(date).getHours();
  let h = hour < 10 ? "0" + hour : hour;
  let minute = new Date(date).getMinutes();
  let m = minute < 10 ? "0" + minute : minute;
  let second = new Date(date).getSeconds();
  let s = second < 10 ? "0" + second : second;

  return h + ":" + m + ":" + s;
};

export default formatTime;
